<div id="{{ componentId }}" class="vtr-ui-hardware-list-test">
	<ul class="list-group modal-scroll">
		<li *ngFor="let item of items; let i = index"
			id="{{ componentId }}-item-{{ i }}"
			class="list-group-item"
			>
			<mat-accordion class="vtr-material-expansion-panel">
				<mat-expansion-panel
					[panelId]="componentId + '-item-' + i"
					[expanded]="item.collapsed"
					(opened)="item.collapsed = true"
					(closed)="item.collapsed = false">
					<mat-expansion-panel-header-customize
						class="module"
						[ngClass]="{'isSelected-item' : item.selected || item.indeterminate}"
						[aria-label]="('hardwareScan.pluginTokens.' + item.name | translateDefault:item.name) + (item.collapsed ? '-collapse-submodules-list': '-expand-submodules-list')">
						<div class="custom-control">
							<vtr-material-checkbox
								[componentId]="componentId + '-item-' + i"
								[ariaLabel]="('hardwareScan.pluginTokens.' + item.name | translateDefault:item.name) + '-checkbox'"
								[indeterminate]="item.indeterminate"
								(toggle)='onDeviceSelectionClicked(item,$event)'
								[checked]="item.selected"
								[hasChild]="true"
							>
								<p id="{{ componentId }}-item-{{ i }}-name" role="text" class="custom-control-label-text name">
									{{ 'hardwareScan.pluginTokens.' + item.name | translateDefault:item.name }}
									<span id="{{ componentId }}-item-{{ i }}-subname" role="text"
										class="subname">{{ 'hardwareScan.pluginTokens.' + item.subname | translateDefault:item.subname }}</span>
								</p>
							</vtr-material-checkbox>
						</div>
					</mat-expansion-panel-header-customize>
					<ng-template matExpansionPanelContent>
						<div id="{{ componentId }}-item-{{ i }}-subitems" class="sub-module">
							<ul class="list-group">
								<li *ngFor="let test of item.tests; let j = index"
									id="{{ componentId }}-item-{{ i }}-subitem-{{ j }}"
									class="list-group-item"
									[ngClass]="{'isSelected-item' : test.selected}"
									>
									<div class="module">
										<div class="custom-control custom-checkbox">
											<vtr-material-checkbox
												componentId="{{ componentId }}-item-{{ i }}-subitem-{{ j }}"
												[ariaLabel]="('hardwareScan.pluginTokens.' + item.name | translateDefault:item.name) + ('hardwareScan.pluginTokens.' + test.name | translateDefault:test.name) + '-checkbox'"
												(toggle)='test.selected = $event;onCheckChildren(item)'
												[checked]="test.selected"
												[hasChild]="true"
											>
												<span class="custom-control-label-text name-test" id="{{ componentId }}-item-{{ i }}-subitem-{{ j }}-name" role="text">
													{{ 'hardwareScan.pluginTokens.' + test.name | translateDefault:test.name }}
												</span>
											</vtr-material-checkbox>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</ng-template>
				</mat-expansion-panel>
			</mat-accordion>
		</li>
	</ul>
	<div class="options">
		<vtr-ui-hyperlink-button
			linkId="hwscan-select-all-tests-link"
			hyperlinkStyle="xs-300-lightGray1"
			class="hyperlink-container"
			(hyperlinkClick)="onSelectAll()"
			[label]=" 'hardwareScan.select' | translate "
			[disableTooltip]="true"
			></vtr-ui-hyperlink-button>
		<span class="select-item-subtitle">/</span>
		<vtr-ui-hyperlink-button
			linkId="hwscan-deselect-all-tests-link"
			hyperlinkStyle="xs-300-lightGray1"
			(hyperlinkClick)="onDeselectAll()"
			[label]=" 'hardwareScan.deselect' | translate "
			[disableTooltip]="true"
		></vtr-ui-hyperlink-button>
	</div>
</div>
